import { AbstractControl, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { SigningRequestChannel } from 'ngx-mat-esign360';

export function RequestChannelContactValidator(
  getSigRequestChannel: () => SigningRequestChannel,
  targetChannel: SigningRequestChannel.Email | SigningRequestChannel.SMS
): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    if (getSigRequestChannel() === targetChannel && Validators.required(control)) {
      return {
        requestChannelContactRequired: true,
      };
    }
    return null;
  };
}
